module.exports = __webpack_public_path__ + "img/1.4d44e009.png";